import { createApi } from '@reduxjs/toolkit/query/react';

import { MonthlyItem } from '@/types/Common';
import { CustomerAgainstWebAlias, CustomPage, RecommendedItemDTO } from '@/types/Customer';
import { ResponseError } from '@/types/Error';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const customerAgainstWebAliasApi = createApi({
  reducerPath: 'customerAgainstWebAliasApi',
  keepUnusedDataFor: 300,
  // baseQuery: fetchBaseQuery({
  //   baseUrl: `${SERVER_URL}/App`,
  //   credentials: 'same-origin',
  //   cache: 'no-store',
  //   prepareHeaders: headers => {
  //     const { origin, host } = globalThis.window?.location || {};
  //     headers.append('Origin', origin);
  //     headers.append('Host', host);
  //     headers.append('__Origin', origin);
  //     return headers;
  //   },
  // }),

  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'App', cache: 'no-store' }),

  tagTypes: ['CustomerAgainstWebAlias', 'GetRecommendedItems', 'CustomPages', 'GetWebsiteMonthlyItemsByCurrentDate'],

  endpoints: builder => ({
    getCustomerAgainstWebAlias: builder.query<SuccessResponse<CustomerAgainstWebAlias>, string>({
      query: webAlias => ({
        url: `/GetCustomerAgainstWebAlias?webAlias=${webAlias}`,
        next: { tags: ['CustomerAgainstWebAlias'] },
      }),

      transformResponse: (response: SuccessResponse<CustomerAgainstWebAlias>) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['CustomerAgainstWebAlias'],
    }),
    getAllCustomPages: builder.query<SuccessResponse<CustomPage[]>, string | number>({
      query: customerID => ({
        url: `/GetAllCustomPages?customerID=${customerID}`,
        next: { tags: ['CustomPages'] },
      }),

      transformResponse: (response: SuccessResponse<CustomPage[]>) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['CustomPages'],
    }),
    getRecommendedItems: builder.query<RecommendedItemDTO[], void>({
      query: () => ({
        url: '/GetRecommendedItems',
        next: { tags: ['GetRecommendedItems'] },
      }),
      transformResponse: (response: RecommendedItemDTO[]) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['GetRecommendedItems'],
    }),
    getWebsiteMonthlyItemsByCurrentDate: builder.query<
      SuccessResponse<MonthlyItem[]>,
      { websiteId: number | string; itemTypeId: number | string }
    >({
      query: ({ itemTypeId, websiteId }) => ({
        url: `/getwebsitemonthlyitemsbycurrentdate?websiteid=${websiteId}&itemtypeId=${itemTypeId}`,
        next: { tags: ['GetWebsiteMonthlyItemsByCurrentDate'] },
      }),
      transformResponse: (response: SuccessResponse<MonthlyItem[]>) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['GetWebsiteMonthlyItemsByCurrentDate'],
    }),
  }),
});

export const {
  useGetCustomerAgainstWebAliasQuery,
  useGetRecommendedItemsQuery,
  useGetAllCustomPagesQuery,
  useGetWebsiteMonthlyItemsByCurrentDateQuery,
} = customerAgainstWebAliasApi;
